
import { Vue, Component, Watch } from "vue-property-decorator";
import Pagination from "@/components/Pagination/index.vue";
import SchoolSelector from "../components/school-selector.vue";
import { orderRecordService } from "@/api/payments/order-record";
import { SchoolService, GradeClassesDto, ExportOrderRecordFaceTemplateDto } from '@/api/service-proxies'
import InputRanger from '@/components/InputRanger.vue'
import XLSX, { WorkSheet } from 'xlsx'

import PagedListBase, {
  PagedRequestDto,
} from "@/lib/view-base/paged-list-base";
import {
  OrderRecordStateCountDto,
  OrderRecordFaceTempleteDtoPagedResultDto,
} from "@/api/service-proxies";
import moment, { Moment } from "moment";

class PageOrderRecordFaceTempleteRequest extends PagedRequestDto {
  tenantId: number = null
  orderNo: string = null
  orderUserNameOrPhoneNumber: string = null
  faceTemplateName: string = null
  gradeNo: number = null
  classNo: number = null
  startDate!: Moment
  endDate!: Moment
  startPayDate!: Moment
  endPayDate!: Moment
  minAmount: number = null
  maxAmount: number = null
  orderRecordState: number | undefined = undefined
  orderRecordWayType!: number | undefined
}

@Component({
  components: {
    Pagination,
    SchoolSelector,
    InputRanger
  },
})
export default class PaymentPayments extends PagedListBase<
  PageOrderRecordFaceTempleteRequest,
  OrderRecordFaceTempleteDtoPagedResultDto
> {
  orderRecordStateCountDto: OrderRecordStateCountDto = new OrderRecordStateCountDto();
  orderRecordState = "all";
  date = [];
  payDate = [];
  amountRange = []
  state: number = null;
  request = new PageOrderRecordFaceTempleteRequest();
  isExporting = false

  private grades: GradeClassesDto[] = []

  private schoolService = new SchoolService()

  private get classes() {
    if (!this.request.gradeNo) return []
    const grade = this.grades.find(x => x.gradeNo === this.request.gradeNo)

    if (grade && grade.classes) {
      return grade.classes
    }
    return []
  }

  created() {
    this.fetchData();
  }

  async fetchData() {
    await this.getOrderRecordStateCount();
    this.refresh()
  }

  getpage(finishCallback: Function): void {
    orderRecordService
      .getPagedOrderRecordFaceTemplete(
        this.request.maxResultCount,
        this.request.skipCount,
        this.request.tenantId,
        this.request.orderNo,
        this.request.orderUserNameOrPhoneNumber,
        this.request.faceTemplateName,
        this.request.gradeNo,
        this.request.classNo,
        this.request.startDate,
        this.request.endDate,
        this.request.startPayDate,
        this.request.endPayDate,
        this.request.minAmount,
        this.request.maxAmount,
        this.request.orderRecordState,
        this.request.orderRecordWayType,
        this.request.sorting
      )
      .then((result) => {
        // result.items.forEach(e=>{
        //   e.faceTemplete.imgUrl = e.faceTemplete.imgUrl+"?auth=wkxiaolvsan";
        // })
        this.list = result.items;
        console.log(this.list)
        this.totalCount = result.totalCount;
      })
      .finally(() => {
        finishCallback();
      });
  }

  async getOrderRecordStateCount() {
    this.orderRecordStateCountDto = await orderRecordService.getOrderRecordStateCount();
  }

  dateChange(e) {
    if (e) {
      this.request.startDate = moment(this.date[0]);
      this.request.endDate = moment(this.date[1]);
    } else {
      this.request.startDate = null;
      this.request.endDate = null;
    }
  }

  payDateChange(e) {
    if (e) {
      this.request.startPayDate = moment(this.payDate[0]);
      this.request.endPayDate = moment(this.payDate[1]);
    } else {
      this.request.startPayDate = null;
      this.request.endPayDate = null;
    }
  }

  tenantChange(e) {
    this.grades = []
    this.request.gradeNo = null
    this.request.classNo = null
    this.request.tenantId = e.tenantId;

    if (!e.tenantId) {
      this.request.faceTemplateName = null
    } else {
      this.schoolService.getTenantAllGrades(this.request.tenantId)
      .then(res => {
        this.grades = res.items
      })
    }
  }

  @Watch("orderRecordState")
  orderRecordStateChange(e) {
    this.state = null
    this.payDate = []
    this.request.startPayDate = null
    this.request.endPayDate = null

    if (this.orderRecordState == "all")
      this.request.orderRecordState = undefined;
    else {
      this.request.orderRecordState = <number>(<unknown>this.orderRecordState);
    }

    this.refresh();
  }

  private async handleExportResult() {
    this.isExporting = true
    try {
      const result = await orderRecordService.getOrderRecordFaceTemplateForExport(
        this.request.tenantId,
        this.request.orderNo,
        this.request.orderUserNameOrPhoneNumber,
        this.request.faceTemplateName,
        this.request.gradeNo,
        this.request.classNo,
        this.request.startDate,
        this.request.endDate,
        this.request.startPayDate,
        this.request.endPayDate,
        this.request.minAmount,
        this.request.maxAmount,
        this.request.orderRecordState,
        this.request.orderRecordWayType,
        this.request.sorting
      )
      result.items.forEach((e)=>{
        if(e.orderRecordState == "Paid"){
          e.orderRecordState = "已支付";
        }else if(e.orderRecordState == "ToBePaid"){
          e.orderRecordState = "未支付";
        }
      })
      this.exportExcel(result.items)
    } finally {
      this.isExporting = false
    }
  }

  private exportExcel(rows: ExportOrderRecordFaceTemplateDto[]) {
    let excelRows = [
      ['学校', '姓名', '班级名称', '商品名称', '商品类别', '支付金额', '支付状态', '支付人', '支付人电话', '下单时间', '支付时间', '订单号', '流水号']
    ]
    for (const row of rows) {
      excelRows.push([
        row.schoolName,
        row.studentName,
        row.className,
        row.body,
        row.title,
        row.amount.toFixed(2),
        row.orderRecordState,
        row.orderUserName,
        row.orderUserPhoneNumber,
        row.creationTime.format('YYYY-MM-DD HH:mm:ss'),
        row.paidTime ? row.paidTime.format('YYYY-MM-DD HH:mm:ss') : '',
        row.orderNo,
        row.serialNo
      ])
    }
    let workSheet = XLSX.utils.aoa_to_sheet(excelRows)
    let workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, workSheet, '订单列表')
    workSheet['!cols'] = [
      { wpx: 150 },
      { wpx: 90 },
      { wpx: 90 },
      { wpx: 130 },
      { wpx: 90 },
      { wpx: 60 },
      { wpx: 60 },
      { wpx: 100 },
      { wpx: 100 },
      { wpx: 130 },
      { wpx: 130 },
      { wpx: 130 },
      { wpx: 200 }
    ]
    XLSX.writeFile(workbook, '订单导出.xlsx')
  }

  @Watch('state')
  onStateChange(e) {
    this.request.orderRecordState = e
  }

  @Watch('amountRange')
  onAmountRange(e) {
    this.request.minAmount = null
    this.request.maxAmount = null

    if (!e || !e.length) return

    if (e[0]) {
      this.request.minAmount = +e[0]
    }

    if (e[1]) {
      this.request.maxAmount = +e[1]
    }
  }
}
